import React, { useState } from "react";
import { PatternlibCheckbox } from "@liebherr/patternlib-react";
import PropTypes from "prop-types";

const FormCheckbox = ({ label, name, initialValue, onChange, error }) => {
  const [value, setValue] = useState(initialValue);

  const onChangeListener = (event) => {
    const value = event.detail.value;
    setValue(value);
    value ? onChange("checked") : onChange("");
  };

  return (
    <PatternlibCheckbox
      checked={initialValue === "checked" ? true : false}
      label={label}
      name={name}
      onLhChange={(e) => onChangeListener(e)}
      status={error !== null ? "error" : "default"}
    ></PatternlibCheckbox>
  );
};

FormCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

FormCheckbox.defaultProps = {
  label: "Label",
  error: null,
};

export default FormCheckbox;
